<template>
  <div id="page-container" v-loading="loadingPayment"></div>
</template>

<script>
import { useCommonStore } from "@/stores/CommonStore.ts";
import { usePaymentStore } from "@/stores/PaymentStore.ts";
import { mapActions, mapState } from "pinia";
import { ElNotification } from 'element-plus';

export default {
  name: "PaymentMedia",
  async mounted() {
    this.loadingPayment = true;
    try{
      // Check whether has query params. 
      // If so, set top bar, store query params, decide flow type
      if(this.$route.query && Object.keys(this.$route.query).length > 0){
        // 1. save query info in localStorage: for user refresh on other pages in single page flow
        localStorage.setItem('pns_single_page_query', JSON.stringify(this.$route.query));

        // 2. set data in CommonStore: for the top header information and 'pnsToken' in localStorage
        this.setAccessionId(this.$route.query.accession_id);
        this.setSampleId(this.$route.query.sample_id);
        this.setJwtToken(this.$route.query.token);

        // 3. set data in PaymentStore: for related apis after redirect to /payment_form, /payment_succeed, /payment_pending or /failed
        // NOTES: need to use await, since storeAllQueryInfomation might throw Error
        await this.storeAllQueryInfomation(this.$route.query);

        // 4. assign order_id, patient_id, customer_id, order_source, charge_type
        await this.initiatePaymentMediaPage();
        // 5. check whether it is from WellProz
        //  5.1 If from wellProz, directly show payment success:
        if(this.order_source == 'WP' || this.order_source == 'Shopify'){
          this.$router.push('/payment_succeed')
        }else if (this.payment_status_index == 4){
        //  5.2 If NOT from wellProz, check payment_status_index
          // if order is cancelled, push to order_cancelled page
          this.$router.push("/order_cancelled");
        }else if(this.payment_status_index == 1){
          this.$router.push("/payment_pending");
        }else{
          // 04/16/2025: payment failed also push to payment_form page, since retryPayment for both PaymentFailedPage and GeneralFailedPage need to redirect to /payment instead of /payment_form
          this.$router.push("/payment_form");
        }
      }else{
        // If no query params, DON'T allow any operations: error notification, clear query in localStorage, and redirect to /failed GeneralFailed page

        //remove previous query info in localStorage: in case there is a previous record there
        localStorage.removeItem('pns_single_page_query');
        ElNotification({
            title: 'Error',
            type: 'error',
            customClass: "errorNotification",
            message: 'No query information found.',
            duration: 0,
        });
        this.$router.push('/failed');
      }
    }catch(err){
      console.log('PaymentMedia mounted error: ', err);
      ElNotification({
          title: 'Error',
          type: 'error',
          customClass: "errorNotification",
          message: err?.message ?? 'PaymentMedia mounted error',
          duration: 0,
      });
      this.$router.push('/failed');
    }finally{
      this.loadingPayment = false;
    }
  },
  data(){
    return{
      loadingPayment:false,
    }
  },
  computed:{
    ...mapState(()=>usePaymentStore(),[
      'sample_id',
      'order_source',
      'payment_status_index'
    ])  
  },
  methods: {
    ...mapActions(()=>useCommonStore(), [
      "setSampleId", 
      "setAccessionId",
      'setJwtToken'
    ]),
    ...mapActions(()=>usePaymentStore(), [
      'storeAllQueryInfomation',
      'initiatePaymentMediaPage',
      "getPaymentStatus",
    ]),
  },
};
</script>
